import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AdminClientContactsPage from "@/pages/admin/AdminClientContactsPage";

export const Route = createFileRoute("/_admin/admin/client-accounts")({
  head: () => pageHead("Client Accounts", "Manage AKIVA customer accounts, invitations and shared work access.", "/admin/client-accounts", true),
  component: AdminClientContactsPage,
});
